import React, { useState } from "react";
import { bake_cookie } from "sfcookies";
import axios from "axios";
import { toast } from "react-toastify";
import util from "../../utils/miniUtils";
const BASE_URL = process.env.REACT_APP_BASE_URL;
import ReCAPTCHA from "react-google-recaptcha";
import "./Login.css";

export default function Login() {
    const [state, setState] = useState( {
        email: "",
        password: "",
        loading: false,
        isHuman: false
    } );

    const tryLogin = async () => {
        try {
            // e.preventDefault();
            if ( !state.isHuman ) throw new Error( "Please verify you are human" );
            setState( { ...state, loading: true } );
            if ( state.email === "" ) throw new Error( "Please enter your email" );
            if ( state.password === "" ) throw new Error( "Please enter your password" );
            const request = await axios.post( `${BASE_URL}/auth/sign_in`, state );
            const { error, msg, accessToken } = request.data;
            if ( error ) throw new Error( msg );
            bake_cookie( "inventory-tkn", accessToken );
            toast.success( msg );
            setTimeout( () => {
                window.location.reload();
            }, 1500 );
        } catch ( e ) {
            setState( { ...state, loading: false } );
            util.handleError( e );
        }
    };

    const onChangeInput = ( e ) => {
        let { name, value } = e.target;
        setState( {
            ...state,
            [name]: value,
        } );
    };

    const captureEnterKey = ( e ) => {
        if ( e.key === "Enter" ) {
            tryLogin().then( null );
        }
    };

    const verifyCallBack = ( data ) => {
        if ( data !== '' ) {
            setState( { ...state, isHuman: true } );
        }
    };

    return (
        <div className="krs-login-wrapper">
            <div className="krs-login-container">
                <div className="krs-login-card">
                    <div className="krs-login-header">
                        <div className="krs-login-logo">
                            <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
                                <circle cx="28" cy="28" r="26" stroke="white" strokeWidth="2"/>
                                <path d="M28 14v28M14 28h28" stroke="white" strokeWidth="2" strokeLinecap="round"/>
                            </svg>
                        </div>
                        <h1 className="krs-login-title">KRSMotocicletas</h1>
                        <p className="krs-login-subtitle">Gestión de Inventario</p>
                    </div>

                    <div className="krs-login-form">
                        <div className="krs-form-group">
                            <label className="krs-form-label">Correo Electrónico</label>
                            <div className="krs-input-wrapper">
                                <svg className="krs-input-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <path d="M2 5h16v10H2V5z" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                                    <path d="M2 5l8 6 8-6" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                                </svg>
                                <input
                                    disabled={state.loading}
                                    onChange={onChangeInput}
                                    type="email"
                                    className="krs-input"
                                    name="email"
                                    placeholder="tu@email.com"
                                />
                            </div>
                        </div>

                        <div className="krs-form-group">
                            <label className="krs-form-label">Contraseña</label>
                            <div className="krs-input-wrapper">
                                <svg className="krs-input-icon" width="20" height="20" viewBox="0 0 20 20" fill="none">
                                    <rect x="3" y="9" width="14" height="8" rx="1" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                                    <path d="M5 9V6a5 5 0 0110 0v3" stroke="currentColor" strokeWidth="1.5" fill="none"/>
                                </svg>
                                <input
                                    disabled={state.loading}
                                    onKeyDown={captureEnterKey}
                                    onChange={onChangeInput}
                                    type="password"
                                    className="krs-input"
                                    name="password"
                                    placeholder="••••••••"
                                />
                            </div>
                        </div>

                        <div className="krs-form-group krs-recaptcha-group">
                            <ReCAPTCHA
                                sitekey={process.env.REACT_APP_SITE_KEY}
                                render="explicit"
                                onChange={verifyCallBack}
                            />
                        </div>

                        <button
                            disabled={state.loading}
                            onClick={tryLogin}
                            className="krs-btn-submit"
                            type="submit">
                            {state.loading ? "Iniciando..." : "Iniciar Sesión"}
                        </button>
                    </div>

                    <div className="krs-login-footer">
                        <p className="krs-login-footer-text">© 2024 KRS Motocicletas. Todos los derechos reservados.</p>
                    </div>
                </div>
            </div>
            {util.LOADING_SCREEN( state.loading )}
        </div>
    );
}
